export const baseURL = "https://brainquire-server.herokuapp.com";
// export const baseURL = "https://aws.brainquire.com";
// export const baseURL  = 'http://localhost:3000';
//export const baseURL = 'https://griceviz.meb.gov.tr'

export const inventoryURL = "https://meslekilgi.com";
